import { render, staticRenderFns } from "./need.vue?vue&type=template&id=79b50bf2&scoped=true&"
import script from "./need.vue?vue&type=script&lang=js&"
export * from "./need.vue?vue&type=script&lang=js&"
import style0 from "./need.vue?vue&type=style&index=0&id=79b50bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b50bf2",
  null
  
)

export default component.exports